import { ListName } from 'apps/posting/models/Post/constants'
import {
  draftsActions,
  historyActions,
  scheduledActions,
} from 'apps/posting/reducers/slices/createPostListSlice'
import * as postSelectors from 'apps/posting/selectors/postSelectors'
import { createAsyncAction } from 'shared/lib/redux'

const sliceActions = {
  [ListName.DRAFTS]: draftsActions,
  [ListName.SCHEDULED]: scheduledActions,
  [ListName.HISTORY]: historyActions,
}

export const loadPostList = createAsyncAction(
  'postListActions/loadPostList',
  async (listName: ListName, { dispatch, getState }) => {
    await dispatch(sliceActions[listName].getNextListFx())
    const items = getState().posts[listName].items

    return { items }
  },
)

export const ensurePostList = createAsyncAction(
  'postListActions/ensurePostList',
  async (listName: ListName, { dispatch, getState }) => {
    const { fetched, loading } = postSelectors.getListMeta(getState(), listName)

    if (!fetched && !loading) {
      await dispatch(sliceActions[listName].getListFx({ payload: { query: {} } }))
    }

    const items = getState().posts[listName].items
    return { items }
  },
)
